import api from "./api";

class DepartmentService {
  async getDataPage(data) {
    const response = await api.get("/organization/departments", {
      params: data
    });
    return response;
  }

  async getItem(id) {
    const response = await api.get(`/organization/departments/${id}`);
    return response;
  }

  async getAll() {
    const response = await api.get("/organization/departments/all");
    return response;
  }

  async getList(data) {
    const response = await api.get("/organization/departments", {
      params: data
    });
    return response;
  }

  async getPivotDepartmentJobPosition(params) {
    const response = await api.get("/organization/pivot-department-jobposition", { params });
    return response;
  }

  async changeStatus(item) {
    return await this.updateOrCreate(item);
  }

  async updateOrCreate(item) {
    if (item.id) {
      const response = await api.put(`/organization/departments/${item.id}`, item);
      return response;
    }
    const response = await api.post("/organization/departments", item);
    return response;
  }

  async destroy(id) {
    const response = await api.delete(`/organization/departments/${id}`);
    return response;
  }
}

export default new DepartmentService();
